// @flow
import React from 'react'
import { LocationOn as LocationOnIcon } from '@material-ui/icons'

function Marker({ children }: { children: React.Node }) {
  return children ?? <LocationOnIcon color='error' />
}

export default Marker
